import { MARKETTYPEV3 } from '../constants/bakery/nft'
import {
  getExchangeNFTs2Contract,
} from '../sushi/exchangeNFTs'

export function userV3NFTContract(sushi: any, type?: string) {
  let contract = getExchangeNFTs2Contract(sushi)
  if (type && MARKETTYPEV3.hasOwnProperty(type)){
    contract = getExchangeNFTs2Contract(sushi)
  }
  return contract
}
